<template lang="pug">
.auth_frame
  .auth_frame_qr
    i18n(:path="frameTitle" class="auth_frame_title")
    .auth_frame_qr_content
      template(v-if="frameContents.length > 0")
        span(v-for="(frameContent, index) in frameContents" :key="index" class="auth_frame_qr_content_item")
          span {{ `${index + 1}.` }}
          i18n(:path="frameContent" tag="span")
    .auth_frame_qr_code
      div(v-if="(message && message.token) || isConnecting" class="d-flex justify-center align-center" style="height: 100%")
        AppLoader
      img(v-if="hasDynamicQr && message" :src="convertBase64(message.qr)" width="202" height="202")
      qrcode-vue(v-if="!hasDynamicQr" :value="value" :size="size" level="H")
      .auth_frame_retry_layer(v-if="hasDynamicQr && isClosed && !isConnecting")
        .auth_frame_retry_layer_container(@click="retryOperation")
          v-icon(size="30") $retry
          span {{ this.$t('misc.auth.retry.qr') }}
  .auth_frame_img
    img(:src='selectedAppView' alt="Selected-App-View")
</template>
<script>
import appView from '@/assets/appView.png';
import appViewEn from '@/assets/appViewEn.png';
import appViewRu from '@/assets/appViewRu.png';
import AppLoader from '@/components/AppLoader';
import { UserService } from '@/services/user-service';
import { convertBase64 } from '@/helpers/base64Encoder';
import { mapGetters, mapActions } from 'vuex';
import QrcodeVue from 'qrcode.vue';

export default {
  name: 'AppFrame',
  components: {
    AppLoader,
    QrcodeVue,
  },
  props: {
    isRegisterVisibility: {
      type: Boolean,
      required: false,
    },
    frameTitle: {
      type: String,
      default: '',
    },
    frameContents: {
      type: Array,
      default: () => [],
    },
    hasDynamicQr: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      value: 'https://sbplus.mpay.az/mpay-link',
      size: 202,
      userAgent: window.navigator.userAgent,
      appView,
      appViewEn,
      appViewRu,
    };
  },
  computed: {
    ...mapGetters('websocket', {
      message: 'getMessage',
      isClosed: 'getIsClosed',
      isConnecting: 'getIsConnecting',
    }),
    selectedAppView() {
      if (localStorage.getItem('lang')) {
        if (localStorage.getItem('lang').toLowerCase() === 'en') {
          return appViewEn;
        }

        if (localStorage.getItem('lang').toLowerCase() === 'ru') {
          return appViewRu;
        }
      }

      return appView;

    },
  },
  watch: {
    message(value) {
      if (value.jwt) {
        UserService.login(value.jwt);
        this.$router.replace({ name: 'dashboard-root' });
      }

      if (!value) {
        this.disconnect();
      }
    },
  },
  methods: {
    ...mapActions('websocket', ['connect', 'disconnect']),
    convertBase64,
    retryOperation() {
      if (this.$route.path !== '/auth/register' && this.$vuetify.breakpoint.width > 800) {
        this.connect(`${process.env.VUE_APP_BACKEND_WS_HOST}qrcode`);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@/styles/auth.scss';
@import '@/styles/components/appFrame.scss';
</style>
